import { render, staticRenderFns } from "./DesktopLineDiyQuotation.vue?vue&type=template&id=2ff8db26&scoped=true&"
import script from "./DesktopLineDiyQuotation.vue?vue&type=script&lang=js&"
export * from "./DesktopLineDiyQuotation.vue?vue&type=script&lang=js&"
import style0 from "./DesktopLineDiyQuotation.vue?vue&type=style&index=0&id=2ff8db26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff8db26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
